<script>
  import { afterUpdate } from "svelte";
  import Highcharts from "highcharts";
  import annotations from "highcharts/modules/annotations";
  import IntersectionObserver from "svelte-intersection-observer";

  //intersecitons
  let oppbyggningIntersect;
  let oppbyggningElement;

  annotations(Highcharts);

  // start the counting and give it a callback when done
  afterUpdate(() => {
    const vekstOljefondetGraph = Highcharts.chart("FPrefinans", {
      chart: {
        type: "column",
        backgroundColor: "rgba(255, 255, 255, 0)",
        style: {
          fontFamily: "E24 text",
        },
      },
      title: {
        text: null,
      },
      plotOptions: {
        column: { stacking: "normal" },
      },
      credits: {
        text: "Analyse basert på lån hentet fra fundingpartner.no",
      },
      xAxis: {
        categories: ["2018", "2019", "2020", "2021", "2022"],
      },
      yAxis: {
        title: {
          text: "Utlånt kapital",
        },
        //hide grid lines
        gridLineWidth: 0,
        opposite: true,
      },
      tooltip: {
        pointFormatter: function () {
          return (
            '<span style="color:' +
            this.series.color +
            '">' +
            this.series.name +
            "</span>: <b>" +
            this.y +
            " kr" +
            "</b><br />"
          );
        },
      },
      series: [
        {
          name: "Refinansieringer",
          data: [0, 2000000, 13900000, 10200000, 116110000],
          color: "#7C70FF",
        },
        {
          name: "Nye Lån",
          data: [13600000, 113900000, 199150000, 464000000, 611990000],
          color: "#4326C8",
        },
      ],
    });
  });
</script>

<main>
  <div class="graph-section">
    <IntersectionObserver
      once
      element={oppbyggningElement}
      bind:intersecting={oppbyggningIntersect}
    >
      <div
        bind:this={oppbyggningElement}
        class="chartContainer"
        class:oppbyggningIntersect
      >
        <div id="FPrefinans" />
      </div>
    </IntersectionObserver>
  </div>
</main>

<style>
  main {
    text-align: center;
    font-family: "E24 text";
    margin: 0 auto;
  }
  .graph-section {
    display: flex;
    box-sizing: border-box;
    padding-top: 5vh;
    padding-bottom: 5vh;
    flex-direction: column;
    justify-content: space-evenly;
  }
  .chartContainer {
    width: 100%;
    box-sizing: border-box;
    opacity: 0;
    -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
  }
  .oppbyggningIntersect {
    opacity: 1;
  }
  /* Here we define our animation with the name "rotate" */
  @media (max-width: 1920px) {
  }
  @media (max-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
